import DeliverMore from './delivermore'

export default DeliverMore
